import { ButtonProps, Button } from "react-bootstrap";
import { ReactComponent as Previous } from "assets/svg/outline-chevron-left.svg";
import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";
// import { usePhonePortraitContext } from "contexts/phone-portrait-context";

const PreviousButton = ({ className, ...props }: ButtonProps) => {
  // const { isPhonePortrait } = usePhonePortraitContext();
  return (
    <Button
      variant={"link"}
      size={"lg"}
      aria-label={"go previous"}
      className={getClasses(styles["pagination-button-previous"], className)}
      {...props}
    >
      <Previous />
    </Button>
  );
};
export default PreviousButton;
